<template>
	<router-view name="sidebar"></router-view>
</template>

<script>
export default {

}
</script>